// Parroquias Guarico
const munCamaguán = ['Camaguán', 'Puerto Miranda', 'Uverito'];
const munChaguaramas = ['Chaguaramas'];
const munElSocorro = ['El Socorro', 'Puerto Miranda', 'Uverito'];
const munSanGerónimoDeGayabal = ['Capital San Gerónimo de Guayabal', 'Cazorla'];
const munLeonardoInfante = ['Capital Valle de La Pascua', 'Espino'];
const munLasMercedes = [
  'Capital Las Mercedes',
  'Cabruta',
  'Santa Rita De Manapire',
];
const munJuliánMellado = ['Capital El Sombrero', 'Sosa'];
const munFranciscoDeMiranda = [
  'Capital Calabozo',
  'El Calvario',
  'El Rastro',
  'Guardatinajas',
];

const munJoséTadeoMonagas = [
  'Capital Altagracia de Orituco ',
  'Lezama',
  'Libertad De Orituco',
  'Paso Real De Macaira ',
  'San Francisco De Macaira',
  'San Rafael De Orituco',
  'Soublette',
];

const munOrtiz = [
  'Capital Ortiz  ',
  'San Francisco De Tiznado',
  'San José De Tiznado',
  'San Lorenzo De Tiznado',
];
const munJoséFélixRibas = ['Capital Tucupido', 'San Rafael De Laya'];
const munJuanGermánRoscio = [
  'Capital San Juan de Los Morros',
  'Cantagallo',
  'Parapara',
];
const munSanJoséDeGuaribe = ['San José De Guaribe'];
const munSantaMaríaDeIpire = ['Capital Santa María de Ipire', 'Altamira'];
const munPedroZaraza = ['Capital Zaraza', 'San José De Unare'];
export const esGuarico = [
  {
    municipio: 'Camaguán',
    parroquias: munCamaguán,
  },
  {
    municipio: 'Chaguaramas',
    parroquias: munChaguaramas,
  },
  {
    municipio: 'El Socorro',
    parroquias: munElSocorro,
  },
  {
    municipio: 'San Gerónimo De Gayabal',
    parroquias: munSanGerónimoDeGayabal,
  },
  {
    municipio: 'Leonardo Infante',
    parroquias: munLeonardoInfante,
  },
  {
    municipio: 'Las Mercedes',
    parroquias: munLasMercedes,
  },
  {
    municipio: 'Julián Mellado',
    parroquias: munJuliánMellado,
  },
  {
    municipio: 'Francisco De Miranda',
    parroquias: munFranciscoDeMiranda,
  },
  {
    municipio: 'José Tadeo Monagas',
    parroquias: munJoséTadeoMonagas,
  },
  {
    municipio: 'Ortiz',
    parroquias: munOrtiz,
  },
  {
    municipio: 'José Felix Ribas',
    parroquias: munJoséFélixRibas,
  },
  {
    municipio: 'Juan Germán Roscio',
    parroquias: munJuanGermánRoscio,
  },
  {
    municipio: 'San José De Guaribe',
    parroquias: munSanJoséDeGuaribe,
  },
  {
    municipio: 'Santa María De Ipire',
    parroquias: munSantaMaríaDeIpire,
  },
  {
    municipio: 'Pedro Zaraza',
    parroquias: munPedroZaraza,
  },
];
